// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconArusd } from "../../../icons/full/build/icon-arusd.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const ArusdIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconArusd.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  ArusdIcon.displayName = 'ArusdIcon';
}

export default ArusdIcon;